import { snakeCase } from "toptaal-shared"
import apiClient from "../client"
import { Filters, ToptaalUserFilters } from "toptaal-shared"
import {
  RegisterFreelanceUserParams,
  PaginatedUserResponse,
  CreateFreelanceUserParams,
  SimpleUserResponse,
  User,
  PaginatedTeacherResponse,
} from "../types/user"
import {
  TopTaalUserGroupsResponse,
  TopTaalUserResponse,
} from "../types/toptaalUser"
import { AuthenticatedSessionResponse } from "../types/auth"

export async function getMe() {
  return await apiClient.get<SimpleUserResponse>("toptaal_users/me").json()
}

export async function getFilteredUsers({
  filters: activeFilters,
  ...rest
}: ToptaalUserFilters) {
  return await apiClient
    .post<PaginatedUserResponse>("toptaal_users/filters", {
      json: {
        ...rest,
        filters: {
          archived: rest.archived,
          ...activeFilters,
          function: activeFilters?.function?.map((value) => snakeCase(value)),
          roles: activeFilters?.roles?.map((value) => snakeCase(value)),
        },
      },
    })
    .json()
}

export async function getFilteredTeachers(filters: Filters) {
  return await apiClient
    .post<PaginatedTeacherResponse>("toptaal_users/teachers", {
      json: filters,
    })
    .json()
}

export async function registerFreelanceUser(data: RegisterFreelanceUserParams) {
  return await apiClient
    .post("toptaal_users/register_freelancer", {
      json: {
        user: data,
      },
    })
    .json()
}

export async function createFreelanceUser(
  data: CreateFreelanceUserParams,
  token: string,
) {
  return await apiClient
    .post<Omit<AuthenticatedSessionResponse, "user">>(
      "auth/create_freelance_user",
      {
        json: {
          token,
          user: data,
        },
      },
    )
    .json()
}

export async function archiveToptaalUser(id: User["userId"]) {
  return await apiClient.post(`toptaal_users/${id}/archive`).json<void>()
}

export async function unarchiveToptaalUser(id: User["userId"]) {
  return await apiClient.post(`toptaal_users/${id}/unarchive`).json<void>()
}

export async function getTopTaalUserById(id: User["userId"]) {
  return await apiClient.get<TopTaalUserResponse>(`toptaal_users/${id}`).json()
}

export async function getTopTaalUserGroups(id: User["userId"]) {
  return await apiClient
    .get<TopTaalUserGroupsResponse>(`toptaal_users/${id}/groups`)
    .json()
}
